export default __webpack_public_path__ + "static/media/x.381ead04.svg";